export const getInitialFormValues = (sku, consumablesMatrixData) => {
    const consumableItem = consumablesMatrixData.items.find((item) => item.product.sku === sku);
    if (!consumableItem) {
        return {
            purchaseType: "regular",
            packagingFormatId: "",
            flavors: null,
            packagingFormat: null,
            quantity: "1",
        };
    }
    const packagingFormat = consumablesMatrixData.packagingFormats.find((format) => format.id === consumableItem.packagingFormatId);
    if (!packagingFormat) {
        return {
            purchaseType: consumableItem.purchaseType,
            packagingFormatId: "",
            packagingFormat: null,
            flavors: null,
            quantity: "1",
        };
    }
    return {
        purchaseType: consumableItem.purchaseType,
        packagingFormatId: packagingFormat.id,
        packagingFormat: packagingFormat,
        flavors: null,
        quantity: "1",
    };
};
//# sourceMappingURL=getInitialFormValues.js.map